import clsx from "clsx";
import VirtualizedItems from "components/VirtualizedItems";
import { bool, func } from "prop-types";
import { useSelector } from "react-redux";
import { selectPageIntros } from "slices/documentViewer/selectors";

import classes from "./PageNavigation.module.scss";
import PageNavigationButton from "./PageNavigationButton";

const PageNavigation = ({ isNarrow, onClickPage }) => {
  const pageIntros = useSelector(selectPageIntros);

  if (pageIntros?.length <= 1) {
    return null;
  }

  return (
    <div
      className={clsx(classes["page_navigation"], isNarrow && classes.narrow)}
    >
      <VirtualizedItems
        data={pageIntros}
        itemClassName={classes["page_navigation__item"]}
      >
        {(pageIntro, virtualItem) => {
          return (
            <PageNavigationButton
              onClickPage={onClickPage}
              page={virtualItem.index + 1}
              textContent={pageIntro}
            />
          );
        }}
      </VirtualizedItems>
    </div>
  );
};

PageNavigation.propTypes = {
  isNarrow: bool,
  onClickPage: func,
};

export default PageNavigation;
